import React, {useState} from "react"
import {Menu as AntMenu, Row} from 'antd'
import {Link} from 'react-router-dom'
import {MenuContainer} from './style'

function Menu(props) {
  const { SubMenu, Item} = AntMenu
  const [openKeys, setOpenKeys] = useState([])
  const example = [
    {
      title: "Dia a dia da ferramenta",
      key: "sub1",
      subItems:[
        {
          title: "Como ligar",
          key: "1",
          link: "/como-ligar"
        },
        {
            title: "Como utilizar",
            key: "2",
            link: "/como-utilizar"
          },
      ],
    },
    {
        title: "Procedimentos para correções",
        key: "sub2",
        subItems:[
          {
            title: "Tela branca",
            key: "3",
            link: "/tela-branca"
          },
          {
              title: "Melhores práticas de uso",
              key: "4",
              link: "/melhores-praticas"
            },
        ],
      },
      {
        title: "Dúvidas, problemas e sugestões",
        key: "5",
        mailto: "mailto:suportesmartstore@dex.co"
      }
  ]

  let content = props.content?props.content:example
  const rootSubmenuKeys = content.map((item)=>{
      let result
      if(item.subItems) result = item.key
      return result
  })
  const onClose = () => {
    props.onClose()
  }

  const onOpenChange = value => {
    const latestOpenKey = value.find(key => openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(value)
    } else {
      latestOpenKey ? setOpenKeys([latestOpenKey]) : setOpenKeys([])
    }
  }

  const generateContent = (content) => {
      return content.map((item)=>{
        let result
          if(item.subItems){
              result = <SubMenu key={item.key} title={item.title}>
                  {item.subItems.map((subItem)=>{
                  return <Item key={subItem.key}>
                      <Link to={subItem.link} style={{textOverflow:'ellipsis', overflow:'hidden'}} onClick={props.onClose?onClose:()=>{}}> 
                        {subItem.title}
                      </Link>
                    </Item>
                    })}
              </SubMenu>
          }
          if(item.link){
              result = <Item key={item.key}>
                <Link to={item.link} style={{textOverflow:'ellipsis', overflow:'hidden'}} onClick={props.onClose?onClose:()=>{}}> 
                        {item.title}
                </Link>
              </Item>
          }
          if(item.mailto){
            result = <Item key={item.key}>
                <a href={item.mailto} style={{textOverflow:'ellipsis', overflow:'hidden'}} onClick={props.onClose?onClose:()=>{}}> 
                        {item.title}
                </a>
              </Item>
          }
          return result
      })
  }
  return (
    <MenuContainer >
      <div className = {props.className}>
      <Row className= 'menu-title'>MENU</Row>
      <AntMenu
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      style={{}}
      expandIcon={' '}
      mode="inline">
          {generateContent(content)}
      </AntMenu>
      </div>
    </MenuContainer>
    )
  
}

export default Menu
